// extracted by mini-css-extract-plugin
export default {"slideShowContainer":"Slider_slideShowContainer__ZlL2l","text":"Slider_text__typlO"};